import { useEffect, useRef } from "react";

export type CheckboxProps<T = string> = {
  id: T;
  itemsChecked: T[];
  setChecked: () => void;
};

export const Checkbox = <T,>({
  id,
  itemsChecked,
  setChecked,
}: CheckboxProps<T>) => {
  const cbRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (cbRef.current) {
      cbRef.current.checked = itemsChecked.includes(id);
    }
  }, [id, itemsChecked]);

  return <input type="checkbox" onChange={setChecked} ref={cbRef} />;
};
